const ListingCreate = () =>
	import(
		/* webpackChunkName: "listingcreate"*/ "@/views/Facility/Create/index.vue"
	);

const ListingBulkEdit = () =>
	import(
		/* webpackChunkName: "listingbulkedit"*/ "@/views/Organisation/BulkEdit/index.vue"
	);

const ListingQuickEdit = () =>
	import(
		/* webpackChunkName: "listingquickedit"*/ "@/views/Organisation/QuickEdits/index.vue"
	);

const OrganisationsList = () =>
	import(
		/* webpackChunkName: "organisationslist"*/ "@/views/OrganisationsList/index.vue"
	);

const OrganisationDashboard = () =>
	import(
		/* webpackChunkName: "organisationdashboard"*/ "@/views/Organisation/Dashboard/index.vue"
	);
const OrganisationDetails = () =>
	import(
		/* webpackChunkName: "organisationdetails"*/ "@/views/Organisation/Details/index.vue"
	);
const OrganisationListings = () =>
	import(
		/* webpackChunkName: "organisationlistings"*/ "@/views/Organisation/Listings/index.vue"
	);

const OrganisationPerformance = () =>
	import(
		/* webpackChunkName: "organisationperformance"*/ "@/views/Organisation/Performance/index.vue"
	);
const OrganisationSettings = () =>
	import(
		/* webpackChunkName: "organisationsettings"*/ "@/views/Organisation/Settings/index.vue"
	);
const OrganisationTeamView = () =>
	import(
		/* webpackChunkName: "organisationteamview"*/ "@/views/Organisation/Team/index.vue"
	);
const OrganisationTeamDirectory = () =>
	import(
		/* webpackChunkName: "organisationteamdirectory"*/ "@/views/Organisation/Team/Directory.vue"
	);
const OrganisationVacancies = () =>
	import(
		/* webpackChunkName: "organisationvacancies"*/ "@/views/Organisation/Vacancies/index.vue"
	);
const OrganisationView = () =>
	import(
		/* webpackChunkName: "organisationview"*/ "@/views/Organisation/index.vue"
	);
const OrganisationUserView = () =>
	import(
		/* webpackChunkName: "organisationteamview"*/ "@/views/Organisation/User/index.vue"
	);
// const OrganisationUserEdit = () =>
// 	import(
// 		/* webpackChunkName: "organisationteamview"*/ "@/views/Organisation/User/Edit.vue"
// 	);

const OrganisationEdit = () =>
	import(
		/* webpackChunkName: "organisationedit"*/ "@/views/Organisation/Edit/index.vue"
	);
const OrganisationsCreate = () =>
	import(
		/* webpackChunkName: "organisationscreate"*/ "@/views/Organisation/Create/index.vue"
	);

const OrganisationsUsersInvite = () =>
	import(
		/* webpackChunkName: "organisationsusersinvite"*/ "@/views/OrganisationsUsersInvite/index.vue"
	);

export default [
	{
		path: "organisations/:id",
		component: OrganisationView,
		children: [
			{
				path: "",
				name: "OrganisationDashboard",
				component: OrganisationDashboard,
				meta: {
					title: "DailyAdmin - Organisation dashboard"
				}
			},
			{
				path: "performance",
				name: "OrganisationPerformance",
				component: OrganisationPerformance,
				meta: {
					title: "DailyAdmin - Organisation performance"
				}
			},
			{
				path: "vacancies",
				name: "OrganisationVacancies",
				component: OrganisationVacancies,
				meta: {
					title: "DailyAdmin - Organisation vacancies"
				}
			},
			{
				path: "listings",
				name: "OrganisationListings",
				component: OrganisationListings,
				meta: {
					title: "DailyAdmin - Organisation listings"
				}
			},
			{
				path: "details",
				name: "OrganisationDetails",
				component: OrganisationDetails,
				meta: {
					title: "DailyAdmin - Organisation details"
				}
			},
			{
				path: "team-roles",
				name: "OrganisationTeamView",
				component: OrganisationTeamView,
				meta: {
					title: "DailyAdmin - Organisation team"
				}
			},
			{
				path: "team-roles/directory",
				name: "OrganisationTeamDirectory",
				component: OrganisationTeamDirectory,
				meta: {
					title: "DailyAdmin - Organisation team directory"
				}
			},
			{
				path: "settings",
				name: "OrganisationSettings",
				component: OrganisationSettings,
				meta: {
					title: "DailyAdmin - Organisation settings"
				}
			}
		]
	},
	{
		path: "organisation/:id/edit",
		name: "OrganisationEdit",
		component: OrganisationEdit,
		meta: {
			title: "DailyAdmin - Organisation edit"
		}
	},
	{
		path: "organisations",
		name: "OrganisationsList",
		component: OrganisationsList,
		meta: {
			title: "DailyAdmin - Super organisations list"
		}
	},
	{
		path: "organisation/create",
		name: "OrganisationsCreate",
		component: OrganisationsCreate,
		meta: {
			title: "DailyAdmin - Organisation create"
		}
	},
	{
		path: "/organisation/:id/create/:type/",
		name: "OrganisationListingCreate",
		component: ListingCreate,
		meta: {
			title: "DailyAdmin - Organisation listing create"
		}
	},
	{
		path: "organisation/invite/:id",
		name: "OrganisationsUsersInvite",
		component: OrganisationsUsersInvite
	},
	{
		path: "organisation/:id/bulk-edit/:category?/:option?/:value?",
		name: "ListingBulkEdit",
		component: ListingBulkEdit,
		meta: {
			title: "DailyAdmin - Listing bulk edit"
		}
	},
	{
		path: "organisation/:id/quick-edit/:option/:value?",
		name: "ListingQuickEdit",
		component: ListingQuickEdit,
		meta: {
			title: "DailyAdmin - Listing bulk edit"
		}
	}
];
